const id = {
  noBroadcastHistoryTitle: "Belum ada riwayat",
  noBroadcastHistoryContent:
    "Info broadcast yang kamu kirim akan muncul di halaman ini.",
  historyBroadcastCampaignCode: "Kode campaign",
  historyBroadcastTimeBroadcast: "Tanggal broadcast",
  historyBroadcastTemplateName: "Nama template",
  historyBroadcastBroadcastTotal: "Total penerima",
  historyBroadcastAccountSender: "Akun pengirim",
  historyBroadcastStatus: "Status",
  historyBroadcastAction: "Aksi",
  historyBroadcastStatusPartially: "Partially failed",
  historyBroadcastStatusDelivered: "Selesai",
  historyBroadcastStatusFailed: "Failed",
  historyBroadcastStatusInProcess: "In process",
  historyBroadcastStatusPendingForApproval: "Butuh pengesahan",
  historyBroadcastStatusCancelled: "Cancelled",
  historyBroadcastErrorGeneral:
    "Gagal mendapatkan data broadcast. Silahkan coba beberapa saat lagi.",
  historyBroadcastErrorCancelSchedule:
    "Gagal membatalkan jadwal pengiriman. Silahkan coba beberapa saat lagi.",
  historyBroadcastViewDetail: "Lihat rincian",
  historyBroadcastEmailCC: "Penerima tambahan",
  historyBroadcastDate: "Tanggal broadcast",
  historyBroadcastCategory: "Kategori",
  historyBroadcastSubCategory: "Subkategori",
  historyBroadcastDetailSender: "Akun pengirim",
  historyBroadcastConnectedTitle: "Telepon tersambung",
  historyBroadcastRejectedTitle: "Telepon tidak tersambung",
  historyBroadcastReadTitle: "Total dibaca",
  historyBroadcastFailedTitle: "Gagal terkirim",
  historyBroadcastPreviousPageButton: "Kembali",
  historyBroadcastDetail: "Detail {0}",
  historyBroadcastDetailEmail: "Detail email",
  labelFilterEmailReceiver: "Cari email penerima",
  labelFilterByStatus: "Tampilkan status",
  historyBroadcastEmailReceiver: "Email penerima",
  historyBroadcastNumberReceiver: "Nomor penerima",
  historyBroadcastSendDate: "Tanggal dikirim",
  historyBroadcastReceivedDate: "Tanggal diterima",
  historyBroadcastReadDate: "Tanggal dibaca",
  historyBroadcastNotificationErrorMessage:
    "Terjadi masalah di email pelanggan: kotak masuk email penuh atau email tidak valid",
  historyBroadcastNotificationErrorVOIMessage:
    "Terjadi masalah di nomor pelanggan: panggilan tidak diangkat, sedang sibuk, atau tidak valid",
  historyBroadcastNotificationErrorSMSMessage:
    "Terjadi masalah di nomor pelanggan: nomor tidak aktif atau tidak valid",
  historyBroadcastFailedToSend: " {0} gagal dikirim ke penerima",
  labelFindReceiver: "Cari penerima",
  labelSelected: "Dipilih: {0}",
  statusFilterSend: "Berhasil",
  statusFilterFailed: "Gagal",
  historyBroadcastNotFound: "Detail broadcast tidak ditemukan!",
  historyBroadcastErrorDownload:
    "Gagal download data broadcast. Silakan coba lagi.",
  historyBroadcastAttemptEmpty: "Belum ada data attempt.",
  historyBroadcastAttemptRefresh: "Perbarui daftar attempt",
  attemptStatusProcessing: "Diproses",
  attemptStatusPendingApproval: "Menunggu Persetujuan",
  attemptStatusRejected: "Ditolak",
  attemptStatusMaxAttempt: "Batas Percobaan Tercapai",
  attemptStatusNoRetry: "Tanpa Percobaan Ulang",
  attemptStatusRejectedApproval: "Ditolak Persetujuan",
  attemptStatusRejectedSystem: "Ditolak (Kesalahan Sistem)",
  attemptStatusBlacklisted: "Masuk Daftar Hitam",
  attemptStatusExpired: "Kedaluwarsa",
  attemptStatusGenerating: "Sedang Membuat",
  attemptStatusCancelled: "Dibatalkan",
  historyBroadcastCheckpointEmpty: "Belum ada checkpoint untuk notifikasi.",
  historyBroadcastPreviewButton: "Preview {0}",
  broadcastScheduleNotFound: "Tidak ada pengiriman terjadwal",
  broadcastScheduledInformation: "Pengiriman terjadwal aktif",
  broadcastCancelScheduleConfirmTitle: "Batalkan Jadwal Broadcast",
  broadcastCancelScheduleConfirmContent:
    "Apakah Anda yakin ingin membatalkan jadwal broadcast ini?",
  broadcastCancelScheduleConfirmNo: "Tidak, tetap jadwalkan",
  broadcastCancelScheduleConfirmYes: "Ya, batalkan",
  broadcastScheduledFor: "Dijadwalkan untuk",
  invalidEmailFormat: "Email tidak valid",
  invalidPhoneNumberFormat: "Nomor telepon tidak valid",
  labelApproveSelected: "Setujui Pilihan",
  labelRejectSelected: "Tolak Pilihan",
  labelResetSelected: "Pulihkan Pilihan",
  labelRejectAll: "Tolak Semua",
  labelApproveAll: "Setujui Semua",
  labelSelect: "Pilih",
  labelRejectNote: "Catatan:",
};

const en = {
  noBroadcastHistoryTitle: "No history yet",
  noBroadcastHistoryContent:
    "Broadcast info that you've sent will appear here.",
  historyBroadcastCampaignCode: "Campaign code",
  historyBroadcastTimeBroadcast: "Broadcast Time",
  historyBroadcastTemplateName: "Template Name",
  historyBroadcastBroadcastTotal: "Total Recipients",
  historyBroadcastAccountSender: "Sender",
  historyBroadcastStatus: "Status",
  historyBroadcastAction: "Action",
  historyBroadcastStatusPartially: "Partially failed",
  historyBroadcastStatusDelivered: "Completed",
  historyBroadcastStatusFailed: "Failed",
  historyBroadcastStatusInProcess: "In process",
  historyBroadcastStatusCancelled: "Cancelled",
  historyBroadcastStatusPendingForApproval: "Need approval",
  historyBroadcastErrorGeneral:
    "Failed get broadcast data. Please try again later.",
  historyBroadcastErrorCancelSchedule:
    "Failed to cancel dispatch schedule. Please try again later.",
  historyBroadcastViewDetail: "View detail",
  historyBroadcastEmailCC: "Additional recipients",
  historyBroadcastDate: "Broadcast date",
  historyBroadcastCategory: "Category",
  historyBroadcastSubCategory: "Subcategory",
  historyBroadcastDetailSender: "Sender account",
  historyBroadcastConnectedTitle: "Voice connected",
  historyBroadcastRejectedTitle: "Voice rejected",
  historyBroadcastReadTitle: "Total read",
  historyBroadcastFailedTitle: "Failed to send",
  historyBroadcastPreviousPageButton: "Back",
  historyBroadcastDetail: "{0} detail",
  historyBroadcastDetailEmail: "Email detail",
  labelFilterEmailReceiver: "Find email receiver",
  labelFilterByStatus: "Show status",
  historyBroadcastEmailReceiver: "Email receiver",
  historyBroadcastNumberReceiver: "Receiver number",
  historyBroadcastSendDate: "Send date",
  historyBroadcastReceivedDate: "Received date",
  historyBroadcastReadDate: "Read date",
  historyBroadcastNotificationErrorMessage:
    "There was an issue with the customer's email: inbox is full or the email is invalid",
  historyBroadcastNotificationErrorVOIMessage:
    "There was an issue with the customer's number: maybe customer did not answer, busy, or number is invalid",
  historyBroadcastNotificationErrorSMSMessage:
    "There was an issue with the customer's number: maybe number is inactive or invalid",
  historyBroadcastFailedToSend: " {0} failed to be delivered to the recipients",
  labelFindReceiver: "Find receiver",
  labelSelected: "Selected: {0}",
  statusFilterSend: "Completed",
  statusFilterFailed: "Failed",
  historyBroadcastNotFound: "Broadcast detail not found!",
  historyBroadcastErrorDownload:
    "Failed to download broadcast list, Please try again.",
  historyBroadcastAttemptEmpty: "No attempt data available.",
  historyBroadcastAttemptRefresh: "Refresh attempt list",
  attemptStatusProcessing: "Processing",
  attemptStatusPendingApproval: "Pending Approval",
  attemptStatusRejected: "Rejected",
  attemptStatusMaxAttempt: "Max Attempt Reached",
  attemptStatusNoRetry: "No Retry",
  attemptStatusRejectedApproval: "Rejected (Approval)",
  attemptStatusRejectedSystem: "Rejected (System Error)",
  attemptStatusBlacklisted: "Blacklisted",
  attemptStatusExpired: "Expired",
  attemptStatusGenerating: "Generating",
  attemptStatusCancelled: "Cancelled",
  historyBroadcastCheckpointEmpty:
    "No checkpoint available for this notification.",
  historyBroadcastPreviewButton: "Preview {0}",
  broadcastScheduleNotFound: "No scheduled dispatch",
  broadcastScheduledInformation: "Active scheduled dispatch",
  broadcastCancelScheduleConfirmTitle: "Cancel Scheduled Broadcast",
  broadcastCancelScheduleConfirmContent:
    "Are you sure you want to cancel this scheduled broadcast?",
  broadcastCancelScheduleConfirmNo: "No, keep it",
  broadcastCancelScheduleConfirmYes: "Yes, cancel",
  broadcastScheduledFor: "Scheduled for",
  invalidEmailFormat: "Invalid email",
  invalidPhoneNumberFormat: "Invalid phone number",

  labelApproveSelected: "Approve selected",
  labelRejectSelected: "Reject selected",
  labelResetSelected: "Reset selected",
  labelRejectAll: "Reject all",
  labelApproveAll: "Approve all",
  labelSelect: "Select",
  labelRejectNote: "Note:",
};

export default { id, en };
